const icons = {};
icons.block = <svg width="20px" height="20px"
xmlns='http://www.w3.org/2000/svg'
fillRule='evenodd'
strokeLinejoin='round'
strokeMiterlimit='2'
clipRule='evenodd'
viewBox='0 0 48 48'
>
<path
  fill='#0058b0'
  fillRule='nonzero'
  d='M46.051 3.307H1.943a.87.87 0 00-.865.865v39.194a.87.87 0 00.865.865h44.108a.869.869 0 00.864-.865V4.167a.868.868 0 00-.864-.86zm-2.887 3.396c0 .877-.722 1.598-1.599 1.598a1.606 1.606 0 01-1.598-1.598c0-.876.722-1.598 1.598-1.598.877 0 1.599.722 1.599 1.598zm-5.928 0c0 .877-.722 1.598-1.598 1.598a1.605 1.605 0 01-1.598-1.598c0-.876.721-1.598 1.598-1.598.876 0 1.598.722 1.598 1.598zm-5.459 0c0 .877-.721 1.598-1.598 1.598a1.605 1.605 0 01-1.598-1.598c0-.874.717-1.594 1.591-1.598h.007c.877 0 1.598.722 1.598 1.598zM2.807 42.497v-31.58h42.379v31.58H2.807z'
></path>
<circle cx='8.451' cy='16.499' r='1.184' fill='#0058b0'></circle>
<circle cx='8.451' cy='30.323' r='1.184' fill='#0058b0'></circle>
<circle cx='8.451' cy='37.095' r='1.184' fill='#0058b0'></circle>
<circle cx='13.625' cy='23.282' r='1.184' fill='#0058b0'></circle>
<path
  fill='#0058b0'
  fillRule='nonzero'
  d='M31.861 15.353H13.714c-.584 0-1.064.517-1.064 1.146 0 .629.48 1.146 1.064 1.146h18.147c.583 0 1.064-.517 1.064-1.146 0-.629-.481-1.146-1.064-1.146zM28.871 21.926H18.448c-.583 0-1.064.517-1.064 1.146 0 .629.481 1.146 1.064 1.146h10.423c.583 0 1.064-.517 1.064-1.146 0-.629-.481-1.146-1.064-1.146zM27.153 29.108H13.615c-.584 0-1.064.517-1.064 1.146 0 .629.48 1.146 1.064 1.146h13.538c.583 0 1.064-.517 1.064-1.146 0-.629-.481-1.146-1.064-1.146zM35.183 35.68H13.718c-.584 0-1.064.518-1.064 1.146 0 .629.48 1.147 1.064 1.147h21.465c.583 0 1.064-.518 1.064-1.147 0-.628-.481-1.146-1.064-1.146z'
></path>
</svg>;
icons.oneColumns = <svg width="20px" height="20px"
xmlns="http://www.w3.org/2000/svg"
fillRule="evenodd"
strokeLinejoin="round"
strokeMiterlimit="2"
clipRule="evenodd"
viewBox="0 0 20 20"
>
<path fill="none" d="M0 0H20V20H0z"></path>
<path
fillRule="nonzero"
d="M2 3h16v2H2V3zm0 4h16v2H2V7zm0 4h16v2H2v-2zm0 4h16v2H2v-2z"
></path>
</svg>;
icons.twoColumns = <svg width="20px" height="20px"
xmlns="http://www.w3.org/2000/svg"
fillRule="evenodd"
strokeLinejoin="round"
strokeMiterlimit="2"
clipRule="evenodd"
viewBox="0 0 20 20"
>
<path fill="none" d="M0 0H20V20H0z"></path>
<path
  fillRule="nonzero"
  d="M9 15v2H2v-2h7zm2 0h7v2h-7v-2zm-2-4v2H2v-2h7zm2 0h7v2h-7v-2zM9 7v2H2V7h7zm2 0h7v2h-7V7zM9 3v2H2V3h7zm2 0h7v2h-7V3z"
></path>
</svg>;
icons.threeColumns = <svg width="20px" height="20px"
xmlns="http://www.w3.org/2000/svg"
fillRule="evenodd"
strokeLinejoin="round"
strokeMiterlimit="2"
clipRule="evenodd"
viewBox="0 0 20 20"
>
<path fill="none" d="M0 0H20V20H0z"></path>
<path
  fillRule="nonzero"
  d="M6 15v2H2v-2h4zm8 0h4v2h-4v-2zm-6 0h4v2H8v-2zm-2-4v2H2v-2h4zm8 0h4v2h-4v-2zm-6 0h4v2H8v-2zM6 7v2H2V7h4zm8 0h4v2h-4V7zM8 7h4v2H8V7zM6 3v2H2V3h4zm8 0h4v2h-4V3zM8 3h4v2H8V3z"
></path>
</svg>;
icons.bullets = <svg width="20px" height="20px"
xmlns="http://www.w3.org/2000/svg"
fillRule="evenodd"
strokeLinejoin="round"
strokeMiterlimit="2"
clipRule="evenodd"
viewBox="0 0 20 20"
>
<path fill="none" d="M0 0H20V20H0z"></path>
<path
fillRule="nonzero"
d="M5.5 7C4.67 7 4 6.33 4 5.5 4 4.68 4.67 4 5.5 4 6.32 4 7 4.68 7 5.5 7 6.33 6.32 7 5.5 7zM8 5h9v1H8V5zm-2.5 7c-.83 0-1.5-.67-1.5-1.5C4 9.68 4.67 9 5.5 9c.82 0 1.5.68 1.5 1.5 0 .83-.68 1.5-1.5 1.5zM8 10h9v1H8v-1zm-2.5 7c-.83 0-1.5-.67-1.5-1.5 0-.82.67-1.5 1.5-1.5.82 0 1.5.68 1.5 1.5 0 .83-.68 1.5-1.5 1.5zM8 15h9v1H8v-1z"
></path>
</svg>;
icons.numbered = <svg width="20px" height="20px"
xmlns="http://www.w3.org/2000/svg"
fillRule="evenodd"
strokeLinejoin="round"
strokeMiterlimit="2"
clipRule="evenodd"
viewBox="0 0 20 20"
>
<path fill="none" d="M0 0H20V20H0z"></path>
<path
  fillRule="nonzero"
  d="M6 7V3h-.69L4.02 4.03l.4.51.46-.37c.06-.05.16-.14.3-.28l-.02.42V7H6zm2-2h9v1H8V5zm-1.23 6.95v-.7H5.05v-.04l.51-.48c.33-.31.57-.54.7-.71.14-.17.24-.33.3-.49.07-.16.1-.33.1-.51 0-.21-.05-.4-.16-.56-.1-.16-.25-.28-.44-.37-.19-.09-.41-.14-.65-.14-.19 0-.36.02-.51.06-.15.03-.29.09-.42.15-.12.07-.29.19-.48.35l.45.54c.16-.13.31-.23.45-.3.15-.07.3-.1.45-.1.14 0 .26.03.35.11.09.08.13.2.13.36 0 .1-.02.2-.06.3-.04.1-.1.21-.19.33-.09.11-.29.32-.58.62l-.99 1v.58h2.76zM8 10h9v1H8v-1zm-1.29 3.95c0-.3-.12-.54-.37-.71-.24-.17-.58-.26-1-.26-.52 0-.96.13-1.33.4l.4.6c.17-.11.32-.19.46-.23.14-.05.27-.07.41-.07.38 0 .58.15.58.46 0 .2-.07.35-.22.43-.15.08-.38.12-.7.12h-.31v.66h.31c.34 0 .59.04.75.12.15.08.23.22.23.41 0 .22-.07.37-.2.47-.14.1-.35.15-.63.15-.19 0-.38-.03-.57-.08-.19-.05-.36-.12-.52-.2v.74c.34.15.74.22 1.18.22.53 0 .94-.11 1.22-.33.29-.22.43-.52.43-.92 0-.27-.09-.48-.26-.64-.17-.16-.42-.26-.74-.3v-.02c.27-.06.49-.19.65-.37.15-.18.23-.39.23-.65zM8 15h9v1H8v-1z"
></path>
</svg>;
icons.none = <svg width="20px" height="20px"
xmlns="http://www.w3.org/2000/svg"
fillRule="evenodd"
strokeLinejoin="round"
strokeMiterlimit="2"
clipRule="evenodd"
viewBox="0 0 20 20"
>
<path fill="none" d="M0 0H20V20H0z"></path>
<path
  fillRule="nonzero"
  d="M4.086 5H17v1H4.086V5zm-.001 5H17v1H4.085v-1zm0 5H17v1H4.085v-1z"
></path>
</svg>;

export default icons;
